import i18n from '@/utils/i18n';
import { Image } from 'expo-image';
import { Typography, XStack } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const HEADER_HEIGHT = 64;
const LOGO_HEIGHT = 26;
const LOGO_WIDTH = 26;

interface MobileDrawerHeaderProps {
  logoUrl?: string;
  supplierName: string;
}

export const MobileDrawerHeader: React.FC<MobileDrawerHeaderProps> = ({
  logoUrl,
  supplierName,
}) => {
  const theme = useTheme();

  return (
    <XStack
      alignItems="center"
      flexShrink={0}
      gap={theme.sk.spacing.spaceSMedium}
      height={HEADER_HEIGHT}
      paddingHorizontal={theme.sk.spacing.spaceMedium}
    >
      {logoUrl ? (
        <Image
          alt={i18n.t('sales_portal.sidebar.logo')}
          contentFit="contain"
          source={{ uri: logoUrl }}
          style={{ height: LOGO_HEIGHT, width: LOGO_WIDTH }}
        />
      ) : null}
      <Typography
        color="$textPrimary"
        flex={1}
        fontWeight="$medium"
        numberOfLines={1}
        size="$lg"
      >
        {supplierName}
      </Typography>
    </XStack>
  );
};
